import Cookies from 'js-cookie';
export const getAccessToken = () => Cookies.get('access_token')

export default {
    // LINK_API : 'https://api.dev.ppdb.kliksekolah.com/public/api/', 
    LINK_API : 'https://api.payment.1toko.com/api/',
    LINK_1TOKO : 'https://api.1toko.com/api/',
    HEADERS_1TOKO : {headers: {'APIKEY': 'QWERTY!@#' }},
    HEADERS_BEARER : {headers: {Authorization: `Bearer `+Cookies.get('access_admin',{ domain: 'admin.1toko.com'})}}
};